import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { api } from '@/utils/api';

export const Heartbeat = () => {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) return;

    const send = () => {
      api.sendHeartbeat().catch(() => {});
    };

    send();
    const interval = setInterval(send, 60000);
    return () => clearInterval(interval);
  }, [isAuthenticated]);

  return null;
};
